// ../../API/basic/Exaustor/acionar.js

/**
 * POST para acionar exaustor (manual) ou unidade (individual).
 * - Manual: envia unidadeId como string "Exaustor X"
 * - Unidade: envia unidadeId como number (ex.: 301)
 *
 * Retorna o corpo JSON do back (ou null em erro), seguindo o padrão do listar.js.
 */

export const acionarExaustor = (exaustor, _command, unidadeIdOverride = null) => {
  const url = `${process.env.REACT_APP_SERVER_IP}/exaustor`;

  try {
    if (!exaustor || typeof exaustor !== "object") {
      console.error("Parâmetro 'exaustor' inválido.");
      return Promise.resolve(null);
    }

    // Decide o que enviar:
    // - number => modo unidade
    // - string "Exaustor X" => modo manual
    const unidadeId =
      typeof unidadeIdOverride === "number"
        ? unidadeIdOverride
        : typeof exaustor.id === "string" && exaustor.id.toLowerCase().startsWith("exaustor")
        ? exaustor.id
        : `Exaustor ${exaustor.id}`;

    // Inclui também o exaustorId no corpo
    const body = {
      unidadeId,
      exaustorId: exaustor.id, // novo campo incluído
    };

    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => {
        return response
          .json()
          .then((data) => ({ ok: response.ok, status: response.status, data }))
          .catch(() => ({ ok: response.ok, status: response.status, data: null }));
      })
      .then((res) => {
        if (!res.ok) {
          console.error(`Falha na requisição HTTP POST (${res.status}).`, res.data);
          return null;
        }
        console.log("POST /exaustor/acionar →", res.data);
        return res.data;
      })
      .catch((error) => {
        console.error("Erro na requisição HTTP POST:", error);
        return null;
      });
  } catch (error) {
    console.error("Erro genérico ao preparar POST:", error);
    return Promise.resolve(null);
  }
};

/**
 * Helper para acionar/desligar uma UNIDADE específica (modo unidade).
 * Usa o mesmo endpoint, porém envia number no payload (unidadeId).
 */
export const acionarUnidade = (exaustor, unidadeId) => {
  const idNum = Number(unidadeId);
  if (Number.isNaN(idNum)) {
    console.error("unidadeId inválido para acionarUnidade:", unidadeId);
    return Promise.resolve(null);
  }
  return acionarExaustor(exaustor, null, idNum);
};

export default acionarExaustor;
